import { Controller } from "@hotwired/stimulus";
import { destroy } from "@rails/request.js";

export default class extends Controller {
  delete(event) {
    event.preventDefault();
    event.stopPropagation();
    const url = event.target.dataset.url;
    const redirectUrl = event.target.dataset.redirectUrl || "/";
    // if (confirm("Weet je het zeker dat je dit wilt verwijderen?")) {
    destroy(url)
      .then((response) => {
        if (response.ok) {
          window.location.href = redirectUrl;
        } else {
          console.log("Error deleting item");
        }
      })
      .catch((error) => {
        console.error("Delete error:", error);
      });
    // }
  }
}
